import { useEffect } from 'react'
import useHttp from '@/shared/hooks/useHttp'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectOrganizationsManagementState } from '@/containers/OrganizationsManagement/organizationsManagementSelectors'
import { setErrors, setOffer, resetOffer } from '@/containers/OrganizationsManagement/organizationsManagementSlice'
import useSaveOffer from '@/containers/OrganizationsManagement/OfferForm/useSaveOffer'

const useOfferEdit = saveFn => {
  const { country } = useSelector(selectAuthData)
  const dispatch = useDispatch()
  const providerState = useSelector(selectOrganizationsManagementState)
  const { sendRequest, getConfig } = useHttp()
  const { offerId } = useParams()
  const isEditMode = !!offerId
  const { saveOffer } = useSaveOffer(saveFn)

  const loadOfferData = async offerId => {
    await sendRequest(
      providerState.routes.offers.information.replace('*', offerId) + '?lang=' + country,
      getConfig('GET'),
      json => dispatch(setOffer(json)),
    )
  }

  useEffect(() => {
    dispatch(setErrors({}))
    if (isEditMode) {
      loadOfferData(offerId)
    } else {
      dispatch(resetOffer())
    }
  }, [offerId])

  const isLoading = isEditMode && !providerState.selectedOffer.id

  return { saveOffer, isLoading }
}

export default useOfferEdit
